/*
  Ported from src/components/ExplodedView.tsx — GSAP ScrollTrigger pin/scrub
  crossfade over 3 transparent product photos, normalized 0->1 timeline.
  Deliberately NOT gated behind prefers-reduced-motion (see source comment):
  this is scroll-scrubbed 1:1 by user input, not an autoplaying animation.
*/
(function () {
  function initExplodedView(root) {
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    var pin = root.querySelector('[data-exploded-pin]');
    var card = root.querySelector('[data-exploded-card]');
    var img1 = root.querySelector('[data-exploded-img="1"]');
    var img2 = root.querySelector('[data-exploded-img="2"]');
    var img3 = root.querySelector('[data-exploded-img="3"]');

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: root,
        start: 'top top',
        end: 'bottom bottom',
        scrub: 0.15,
        pin: pin,
        pinSpacing: true,
      },
      defaults: { ease: 'none' },
    });

    /*
      Re-paced from the original port: the source timeline packed each
      image-to-image crossfade into a ~6-8% sliver of the 0-1 scroll range,
      with long flat "nothing is moving" stretches between them (e.g. img2
      sat at flat opacity 1 from 0.08 all the way to 0.40). Scrolling through
      a long static hold and then hitting an near-instant opacity swap reads
      as a flash/cut, not a dissolve. Spreading each crossfade across ~18-20%
      of the range removes the dead zones and makes the transition itself
      visible as it happens.
    */
    tl.fromTo(card, { scale: 0.82, y: 40 }, { scale: 1, y: 0, duration: 0.12 }, 0)
      .to(root.querySelector('[data-exploded-title]'), { opacity: 0, y: -20, duration: 0.08 }, 0)
      .fromTo(img1, { scale: 1.04 }, { scale: 1.1, duration: 0.32 }, 0)
      .to(img1, { opacity: 0, scale: 0.97, duration: 0.18 }, 0.14)
      .fromTo(img2, { opacity: 0, scale: 1.1 }, { opacity: 1, scale: 1.02, duration: 0.18 }, 0.14)
      .to(img2, { scale: 1.08, duration: 0.18 }, 0.32)
      .to(img2, { opacity: 0, scale: 0.97, duration: 0.18 }, 0.5)
      .fromTo(img3, { opacity: 0, scale: 1.1 }, { opacity: 1, scale: 1.02, duration: 0.18 }, 0.5)
      .to(img3, { scale: 1.08, duration: 0.32 }, 0.68)
      .fromTo(root.querySelector('[data-exploded-callout="mesh"]'), { opacity: 0, x: -16 }, { opacity: 1, x: 0, duration: 0.1 }, 0.05)
      .fromTo(root.querySelector('[data-exploded-callout="audio"]'), { opacity: 0, x: 16 }, { opacity: 1, x: 0, duration: 0.1 }, 0.25)
      .fromTo(root.querySelector('[data-exploded-callout="battery"]'), { opacity: 0, x: -16 }, { opacity: 1, x: 0, duration: 0.1 }, 0.55)
      .fromTo(root.querySelector('[data-exploded-callout="seal"]'), { opacity: 0, x: 16 }, { opacity: 1, x: 0, duration: 0.1 }, 0.75)
      .to(card, { scale: 1.05, duration: 0.15 }, 0.85);
  }

  function boot() {
    document.querySelectorAll('[data-oblivion-exploded-view]').forEach(initExplodedView);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
